var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui small input",attrs:{"id":_vm._uid}},[_c('input',{staticClass:"money input",domProps:{"value":_vm.valueInput},on:{"blur":function($event){_vm.valueInput = $event.target.value}}})])}
var staticRenderFns = []

export { render, staticRenderFns }